<template>
   <div><h1>reading page</h1></div>
  
</template>

<script lang="ts">
export default {

}
</script>

<style>

</style>